import api from './api'

export const authorService = {
  getAllAuthors: async () => {
    const response = await api.get('/authors')
    return response.data
  },

  getAuthorById: async (id) => {
    const response = await api.get(`/authors/${id}`)
    return response.data
  },

  createAuthor: async (data) => {
    const response = await api.post('/authors', data)
    return response.data
  },

  updateAuthor: async (id, data) => {
    const response = await api.put(`/authors/${id}`, data)
    return response.data
  },

  deleteAuthor: async (id) => {
    const response = await api.delete(`/authors/${id}`)
    return response.data
  },

  uploadImage: async (id, file) => {
    const formData = new FormData()
    formData.append('image', file)
    const response = await api.post(`/authors/${id}/image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    return response.data
  }
}

export function getImageUrl(path) {
  if (!path) return ''
  if (/^https?:\/\//i.test(path)) return path
  const resolvedPath = path.startsWith('/') ? path : `/${path}`
  return resolvedPath
}
